<template>
  <div class="request-contact-info-main-section mt-4">
    <section-title content="Documentos a Añadir" :has-line="true" />
    <div class="bg-light rounded mobile" :class="isReadOnly ? '' : 'p-4'">
      <div v-if="!editing" class="panel-row-without-selector mb-4">
        <div class="col-md-12 col-sm-12 text-center mt-3">
          <button
            v-if="!isReadOnly"
            class="btn bg-light-white w-75 pt-1"
            @click.prevent="editing = true"
          >
            <em class="fas fa-file-plus pr-4 text-green" />
            <span class="text-button-add-document">
              Presione aqu&iacute; para anejar documento
            </span>
          </button>
        </div>
      </div>
      <div v-else>
        <validation-observer
          v-if="!isReadOnly"
          ref="remProDocumentForm"
          v-slot="{}"
          tag="form"
        >
          <div class="row mt-0 mb-5">
            <div class="col-lg-4 col-md-6 col-sm-12">
              <validation-provider
                v-slot="{ errors }"
                name="documentType"
                rules="required"
              >
                <custom-drop-down
                  v-model="documentTypeSelected"
                  custom-error-msg="El tipo de documento es requerido."
                  :error="errors[0]"
                  fieldkey="documentTypeId"
                  fieldname="documentTypeName"
                  label="Tipo de Documento:"
                  :options="documentTypesOptions"
                  placeholder="Seleccione"
                  @input="onDocumentTypeChange"
                />
              </validation-provider>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 file-custom">
              <validation-provider
                v-slot="{ errors }"
                name="fileUpload"
                rules="required"
              >
                <label class="data-name">Archivo:</label>
                <custom-file-input
                  ref="proRemfileUpload"
                  :accept="allowedFiles"
                  accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
                  :attachment-id="document.id"
                  :custom-error-msg="'El documento es requerido.'"
                  display-style="normal"
                  :error="errors[0]"
                  :on-download="onDownloadFile"
                  required
                  :value="document.attachment"
                  @input="onChangeFile"
                />
              </validation-provider>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12">
              <div
                class="
                  d-flex
                  flex-row-reverse
                  bd-highlight
                  w-100
                  pt-1_8
                  pr-5
                  actions
                "
              >
                <div class="bd-highlight ml-2 col-custom-6">
                  <action-button
                    i="fas fa-file-plus fa-lg"
                    text="Añadir"
                    variant="success"
                    @click="addDocument"
                  />
                </div>
                <div class="mx-0 mr-2 bd-highlight col-custom-6">
                  <action-button
                    id="modal-btn-cancelar"
                    i="fas fa-times-circle"
                    text="Cancelar"
                    variant="outline-danger"
                    @click="cancelDocument"
                  />
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
      <hr class="mr-2 ml-2" />
      <div
        v-for="(item, key) in model"
        :key="key"
        class="row board-radius"
        :class="[
          isReadOnly ? 'mx-1 py-2 mb-0' : '',
          key === model.length - 1 ? '' : 'border-bottom border-white',
        ]"
      >
        <div class="col">
          <div class="">
            <label class="data-name">Documento:</label>
            <div class="position-relative">
              <label>{{ item.documentTypeDesc }}</label>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="">
            <label class="data-name">Archivo:</label>
            <div class="position-relative">
              <label>{{ item.attachment.name || item.filename }}</label>
            </div>
          </div>
        </div>
        <div class="col d-flex align-items-center justify-content-end">
          <DropDown
            v-if="!isReadOnly"
            class="custom-drop-down-documents"
            :items="actionsDropdownConfig(item)"
          />
          <action-button
            v-else
            i="fas fa-file-download mr-n1 pr-1"
            variant="outline-success"
            @click="$emit('on-download', item)"
          />
        </div>
      </div>
      <div v-if="model.length === 0 && isReadOnly" class="pt-1 pb-4">
        <custom-result-not-found
          text="No cuenta con documentos anejados en sistema."
        />
      </div>
    </div>
  </div>
</template>

<script>
import objectToFormData from 'object-to-formdata';
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomFileInput from 'CustomFileInput';
import alert from '@quisit/mipe-utils/mixins/alert.mixin.js';
import DropDown from 'dropdown';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomResultNotFound from 'custom-result-not-found';
import {
  savedDocuments as _savedDocuments,
  removeDocument as _removeDocument,
} from '@/services/provider/closing-analysis.api';
const DOCUMENT_TYPE_OTHER = 1574;

export default {
  name: 'RequestDocuments',
  components: {
    SectionTitle,
    CustomDropDown,
    ActionButton,
    CustomFileInput,
    DropDown,
    ValidationProvider,
    ValidationObserver,
    CustomResultNotFound,
  },
  mixins: [alert],
  props: {
    value: {
      type: Array,
      required: false,
      default: () => {},
    },
    documents: {
      type: Array,
      required: true,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    compensatoryRequestId: {
      type: Number,
      default: () => 0,
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.isReadOnly) {
          this.model = newVal;
        }
      }
    },
  },
  data() {
    return {
      editing: false,
      allowedFiles: '.pdf',
      documentTypeSelected: null,
      document: {
        id: null,
        attachment: null,
        documentTypeId: null,
        documentTypeDesc: null,
      },
      documentTypesUnique: [DOCUMENT_TYPE_OTHER],
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    actionsDropdownConfig() {
      return (item) => [
        {
          label: 'Descargar',
          icon: 'fas fa-file-download text-green',
          click: () => this.downloadFile(item),
        },
        {
          label: 'Eliminar',
          icon: 'fa fa-times-circle text-red',
          click: () => this.deleteFile(item),
        },
      ];
    },
    studentBoardDetails() {
      return [
        [
          {
            label: 'Documento:',
            data: 'dasda',
            icon: 'fas fa-address-book',
            cols: 'col-lg-4 w-50',
          },
          {
            label: 'Número de Registro:',
            data: 'dasda',
            icon: 'fas fa-address-book',
            cols: 'col-lg-4 w-50',
          },
          {
            label: 'Impedimento:',
            data: 'dasda',
            icon: 'fas fa-ballot-check',
            cols: 'col-lg-4 w-50',
          },
        ],
      ];
    },
    hasDocuments() {
      return Boolean(this.model) && this.model.length > 0;
    },
    documentTypesOptions() {
      const options = [...this.documents];

      const added = this.model
        .filter((x) => !this.documentTypesUnique.includes(x.documentTypeId))
        .map((s) => s.documentTypeId);

      return options.filter((x) => !added.includes(x.documentTypeId));
    },
  },
  methods: {
    async addDocument(e) {
      const isFormValid = await this.$refs.remProDocumentForm.validate();
      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      this.document.id = this.builtUniqueId();
      this.document.documentTypeId = this.documentTypeSelected.documentTypeId;
      this.document.documentTypeDesc = this.documentTypeSelected.documentTypeName;

      const params = objectToFormData(
        {
          compensatoryRequestId: this.compensatoryRequestId,
          contractId: this.contractId,
          file: this.document.attachment,
          documentTypeId: this.document.documentTypeId,
        },
        { indices: true, nullsAsUndefineds: true }
      );

      const { data: result } = await _savedDocuments(params).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });

      if (result) {
        this.ShowToast(
          'Proceso Exitoso',
          'Documento agregado correctamentes.',
          'success'
        );
        this.readOnly = true;
        this.document.id = result.value;
        this.model.id = result.value;
        this.model.push({ ...this.document });
        this.$emit('saved', result);
        this.$emit('input', this.model);
      }

      this.document = {
        id: null,
        attachment: null,
        documentTypeId: null,
        documentTypeName: null,
        documentTypeDesc: null,
      };
      this.documentTypeSelected = null;
      this.$refs.proRemfileUpload.removeFile(e);
      this.$refs.remProDocumentForm.reset();
      this.editing = false;
    },
    onChangeFile(file) {
      if (file) {
        this.showModal = true;
        this.document.attachment = file;
      }
    },
    cancelDocument() {
      this.editing = false;
      this.acceptedTerms = false;
      this.$refs.remProDocumentForm.reset();
    },
    async onDownloadFile() {
      return new Promise();
    },
    downloadFile(item) {
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      let reader = new FileReader();
      reader.readAsDataURL(item.attachment);
      reader.onloadend = () => {
        const url = reader.result;
        a.href = url;
        a.download = item.attachment.name;
        a.click();
        window.URL.revokeObjectURL(url);
      };
    },
    async deleteFile(item) {
      const { data: result } = await _removeDocument(item.id).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });

      if (result) {
        this.ShowToast(
          'Proceso Exitoso',
          'Documento eliminado correctamente.',
          'success'
        );
        const index = this.model.findIndex((x) => x.id === item.id);
        this.model.splice(index, 1);
        this.$emit('input', this.model);
      }
    },
    onDocumentTypeChange(item) {
      if (this.document) {
        this.document.documentTypeId = item ? item.id : null;
        this.document.documentTypeName = item ? item.name : null;
        this.document.documentTypeDesc = 'Test';
      }
    },
    builtUniqueId() {
      return (
        Date.now().toString(36) +
        Math.random()
          .toString(36)
          .substr(2)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.pt-1_8 {
  padding-top: 1.8rem !important;
}
.custom-drop-down-documents {
  text-align: right !important;
}

.custom-drop-down-documents > div.dropdown {
  padding-top: 10px !important;
}

@media screen and (max-width: 768px) {
  ::v-deep .file-custom > span > div > div.col-sm-6 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }

  div.actions button {
    width: 98% !important;
  }
  div.actions {
    padding-right: 0 !important;
  }
  div.actions div {
    margin: 0px 0px 0px 0px !important;
  }
  div.actions div.col-custom-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  div.bg-light.rounded.mobile {
    padding: 0.5rem !important;
  }

  ::v-deep #dropdownMenuButton {
    width: 97% !important;
    display: block !important;
  }

  ::v-deep div.dropdown-menu {
    width: 80% !important;
    top: 0 !important;
  }
  .custom-drop-down-documents {
    width: 100% !important;
  }
}
</style>
